<template>
  <v-list nav dense>
    <v-list-item @click="navigateTo('/products')" :class="{ 'active': isActive('/products') }">
      <v-list-item-icon><v-icon :color="isActive('/products') ? 'primary' : 'black'">mdi-package-variant</v-icon></v-list-item-icon>
      <v-list-item-title>{{ $t('navigation_products') }}</v-list-item-title>
    </v-list-item>

    <v-list-item @click="navigateTo('/gallery')" v-if="totalCodesCount" :class="{ active: isActive('/gallery') }">
      <v-list-item-icon><v-icon :color="isActive('/gallery') ? 'primary' : 'black'">mdi-image-multiple</v-icon></v-list-item-icon>
      <v-list-item-title>{{ $t('navigation_gallery') }}</v-list-item-title>
    </v-list-item>

    <v-list-item @click="navigateTo('/')" :class="{ active: isActive('/') }">
      <v-list-item-icon><v-icon :color="isActive('/') ? 'primary' : 'black'" >mdi-view-dashboard</v-icon></v-list-item-icon>
      <v-list-item-title>{{ $t('navigation_dashboard') }}</v-list-item-title>
    </v-list-item>

    <v-list-item @click="navigateTo('/upgrade?source=menu')" :class="{ active: isActive('/upgrade') }">
      <v-list-item-icon><v-icon :color="isActive('/upgrade') ? 'primary' : 'black'" >mdi-credit-card-outline</v-icon></v-list-item-icon>
      <v-list-item-title>{{ $t('navigation_plans') }}</v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>

import amplitude from 'amplitude-js'
import { mapGetters } from 'vuex'

export default {
  name: 'NavigationMobile',
  props: ['active'],
  computed: {
    ...mapGetters(['totalCodesCount'])
  },
  methods: {
    navigateTo (path) {
      this.$router.push(path)
      this.$emit('close')
    },

    isActive (path) {
      return this.$route.path === path
    },

    sendNavigationEvent (tabName) {
      amplitude.getInstance().logEvent(`${tabName} open`)
      parent.postMessage({ type: 'navigation', data: tabName }, '*')
    }
  }
}

</script>

<style lang="sass" scoped>

@import '@/variables.sass'

.v-list-item
  &.active
    color: $primary !important
    .v-list-item__title
      font-weight: 700 !important

</style>
